<template>
  <h1 class="component-heading">Email</h1>
  <p class="component-description">
    <b>Email</b> has become an essential communication channel for individuals
    and businesses a like
  </p>

  <h2 class="component-side-heading">Email</h2>
  <p class="component-description">
    Attribute <b>type</b> may have values such as <b>individual</b>,
    <b>multi</b>.
  </p>
  <div class="component-example">
    <div
      class="example-body3"
      style="background-color: white; border-radius: 5px"
    >
      <hlx-button class="primary sm" @click="shomailfh">
        <i class="icon-plus-circle-regular"></i>
        Email box
      </hlx-button>

      <hlx-email
        :key="component"
        :recipient="emailData"
        :show="shomail"
        :type="'individual'"
        :load-attachmnet="isLoadervar"
        @updated-email-content="updatedEmail"
        @attachments="emailAttachment"
        @upload-data="valuemail"
        @close="shomail = false"
      >
      </hlx-email>
      <!-- :default-to="defaultTo" -->
    </div>
    <div class="example-footer">
      <span id="email-icon" class="icon" @click="showCode('email')"
        ><i class="icon-code-regular"></i
      ></span>
    </div>
  </div>
  <div id="email" class="source-code" style="display: none">
    <section class="example-source-wrapper">
      <div class="source">
        <CodeEditor
          :id="'editor'"
          :display_language="false"
          :value="email"
          :read_only="true"
          :theme="editor_theme"
          :languages="[
            ['Javascript', 'Vue'],
            ['javascript', 'JS'],
            ['python', 'Python'],
          ]"
        />
      </div>
    </section>
  </div>

  <h2 class="component-side-heading">Attributes</h2>
  <hlx-table
    :column-count="6"
    :border="['table', 'header', 'vertical', 'horizontal']"
    :bold-headers="false"
    :row-hover="false"
    theme="grey"
    :striped-rows="false"
  >
    <template #thead>
      <hlx-table-head
        v-for="(i, index) in treeAttributes"
        :key="index"
        :width="i.width"
        >{{ i.label }}</hlx-table-head
      >
    </template>
    <template #tbody>
      <tr v-for="(i, index) in table_data" id="" :key="index">
        <hlx-table-cell
          v-for="(j, col_index) in treeAttributes"
          :key="col_index"
          :align="'left'"
        >
          {{ i[j.prop] }}
        </hlx-table-cell>
      </tr>
    </template>
  </hlx-table>

  <h2 class="component-side-heading">Events</h2>
  <hlx-table
    :border="['table', 'header', 'vertical', 'horizontal']"
    :bold-headers="false"
    :row-hover="false"
    theme="grey"
    :striped-rows="false"
    :column-count="3"
  >
    <template #thead>
      <hlx-table-head
        v-for="(i, index) in events"
        :key="index"
        :width="i.width"
        >{{ i.label }}</hlx-table-head
      >
    </template>
    <template #tbody>
      <tr v-for="(i, index) in event_data" id="" :key="index">
        <hlx-table-cell
          v-for="(j, col_index) in events"
          :key="col_index"
          :align="'left'"
        >
          {{ i[j.prop] }}
        </hlx-table-cell>
      </tr>
    </template>
  </hlx-table>
  <hlx-divider :space="'20px'" class="mobile-nav-divider" />
  <div class="mobile-next-page-nav">
    <span class="prev-btn" @click="prevNextPage('prev', 'tabs')"
      ><i class="icon-angle-left-regular prev-icon"></i>Tab</span
    >
    <span class="nxt-btn" @click="prevNextPage('next', 'speeddial')"
      >Speed dial <i class="icon-angle-right-regular"></i
    ></span>
  </div>
</template>
<script>
import HlxEmail from "../components/EmailComponent.vue";

import CodeEditor from "simple-code-editor";
import hlxButton from "../components/ButtonComponent.vue";
import hlxTable from "../components/table/HlxTable.vue";
import hlxTableHead from "../components/table/HlxTableHead.vue";
import hlxTableCell from "../components/table/HlxTableCell.vue";
import hlxDivider from "../components/DividerComponent.vue";
export default {
  name: "HlxEmailView",
  components: {
    HlxEmail,
    hlxTableCell,
    hlxTableHead,
    hlxTable,
    hlxButton,
    CodeEditor,
    hlxDivider,
  },
  data() {
    return {
      isLoadervar: true,
      component: 1,
      shomail: false,
      loadAttachmnet: true,
      emailData: [
        {
          _id: "667a34f71400e9354a65ff7c",
          id: "667a34f71400e9354a65ff7c",
          firstName: "keerthi",
          lastName: "kannan",
          name: "keerthikannan",
          email: "keerthika@gmail.com",
          type: "individual",
          company: "amazoninc__lnd",
          root: "developerHalleyx",
          impersonation: false,
          externalReference: [
            {
              name: "",
              externalIdentifierType: "linkedIn",
            },
          ],
          notes: [],
          birthDate: "",
          title: "",
          contactMedium: [
            {
              preferred: false,
              mediumType: "email",
              characteristic: {
                emailAddress: "keerthika@gmail.com",
              },
            },
            {
              mediumType: "phone",
              characteristic: {
                phoneNumber: {
                  value: "",
                  valid: true,
                  country: {
                    name: "United Kingdom",
                    short: "GB",
                    flags: "https://flagcdn.com/gb.svg",
                    dial_code: "+44",
                  },
                },
              },
              preferred: false,
            },
            {
              mediumType: "postalAddress",
              characteristic: {
                city: "",
                country: "",
                postCode: "",
                stateOrProvince: "",
                street1: "",
                street2: "",
                timezone: "",
                description: "",
                "@type": "",
              },
              preferred: false,
            },
          ],
          givenName: "keerthikannan",
          familyName: "keerthikannan",
          otherName: [],
          individualIdentification: [],
          disability: [],
          languageAbility: [],
          attachment: [],
          skill: [],
          relatedParty: [],
          status: "Active",
          createdAt: "2024-06-25T03:09:05.495Z",
          lastVisit: "2024-06-25T03:09:05.495Z",
          lastUpdate: "2024-06-25T03:09:05.495Z",
          displayID: "CMC-0001",
          "@baseType": "customer",
          __v: 0,
          role: [
            {
              _id: "667a34f81400e9354a65ff99",
              name: "Root admin",
              "@type": "partyRole",
              relatedParty: [
                {
                  id: "667a34f71400e9354a65ff7c",
                },
              ],
              account: [],
              paymentMethod: [],
              contactMedium: [],
              characteristic: [],
              creditProfile: [],
              lastUpdate: "2024-06-25T03:09:05.870Z",
              agreement: [],
              privilage: [],
              __v: 0,
            },
          ],
        },
        {
          _id: "667a351d1400e9354a65ffb2",
          id: "667a351d1400e9354a65ffb2",
          firstName: "maara",
          lastName: "",
          name: "maara",
          email: "maara@gmail.com",
          type: "individual",
          company: "amazoninc__lnd",
          root: "developerHalleyx",
          impersonation: false,
          externalReference: [
            {
              name: "",
              externalIdentifierType: "linkedIn",
            },
          ],
          notes: [],
          birthDate: "",
          title: "",
          contactMedium: [
            {
              preferred: false,
              mediumType: "email",
              characteristic: {
                emailAddress: "maara@gmail.com",
              },
            },
            {
              mediumType: "phone",
              characteristic: {
                phoneNumber: {
                  value: "",
                  valid: true,
                  country: {
                    name: "United Kingdom",
                    short: "GB",
                    flags: "https://flagcdn.com/gb.svg",
                    dial_code: "+44",
                  },
                },
              },
              preferred: false,
            },
            {
              mediumType: "postalAddress",
              characteristic: {
                city: "",
                country: "",
                postCode: "",
                stateOrProvince: "",
                street1: "",
                street2: "",
                timezone: "",
                description: "",
                "@type": "",
              },
              preferred: false,
            },
          ],
          givenName: "maara",
          familyName: "maara",
          otherName: [],
          individualIdentification: [],
          disability: [],
          languageAbility: [],
          attachment: [],
          skill: [],
          relatedParty: [],
          status: "Active",
          createdAt: "2024-06-25T03:09:05.495Z",
          lastVisit: "2024-06-25T03:09:05.495Z",
          lastUpdate: "2024-06-25T03:09:05.495Z",
          displayID: "CMC-0002",
          "@baseType": "customer",
          __v: 0,
          role: [
            {
              _id: "667a351d1400e9354a65ffca",
              name: "Root admin",
              "@type": "partyRole",
              relatedParty: [
                {
                  id: "667a351d1400e9354a65ffb2",
                },
              ],
              account: [],
              paymentMethod: [],
              contactMedium: [],
              characteristic: [],
              creditProfile: [],
              lastUpdate: "2024-06-25T03:09:05.870Z",
              agreement: [],
              privilage: [],
              __v: 0,
            },
          ],
        },
        {
          _id: "667a363a1400e9354a66001a",
          id: "667a363a1400e9354a66001a",
          firstName: "jon",
          lastName: "",
          name: "jon",
          email: "jon@gmail.co",
          type: "individual",
          company: "amazoninc__lnd",
          root: "developerHalleyx",
          impersonation: false,
          externalReference: [
            {
              name: "",
              externalIdentifierType: "linkedIn",
            },
          ],
          notes: [],
          birthDate: "",
          title: "",
          contactMedium: [
            {
              preferred: false,
              mediumType: "email",
              characteristic: {
                emailAddress: "jon@gmail.co",
              },
            },
            {
              mediumType: "phone",
              characteristic: {
                phoneNumber: {
                  value: "",
                  valid: true,
                  country: {
                    name: "United Kingdom",
                    short: "GB",
                    flags: "https://flagcdn.com/gb.svg",
                    dial_code: "+44",
                  },
                },
              },
              preferred: false,
            },
            {
              mediumType: "postalAddress",
              characteristic: {
                city: "",
                country: "",
                postCode: "",
                stateOrProvince: "",
                street1: "",
                street2: "",
                timezone: "",
                description: "",
                "@type": "",
              },
              preferred: false,
            },
          ],
          givenName: "jon",
          familyName: "jon",
          otherName: [],
          individualIdentification: [],
          disability: [],
          languageAbility: [],
          attachment: [],
          skill: [],
          relatedParty: [],
          status: "Active",
          createdAt: "2024-06-25T03:09:05.495Z",
          lastVisit: "2024-06-25T03:09:05.495Z",
          lastUpdate: "2024-06-25T03:09:05.495Z",
          displayID: "CMC-0003",
          "@baseType": "customer",
          __v: 0,
          role: [
            {
              _id: "667a363a1400e9354a660032",
              name: "Root admin",
              "@type": "partyRole",
              relatedParty: [
                {
                  id: "667a363a1400e9354a66001a",
                },
              ],
              account: [],
              paymentMethod: [],
              contactMedium: [],
              characteristic: [],
              creditProfile: [],
              lastUpdate: "2024-06-25T03:09:05.870Z",
              agreement: [],
              privilage: [],
              __v: 0,
            },
          ],
        },
        {
          _id: "667a364f1400e9354a66004b",
          id: "667a364f1400e9354a66004b",
          firstName: "jon petter",
          lastName: "",
          name: "jonpetter",
          email: "petter@gmail.com",
          type: "individual",
          company: "amazoninc__lnd",
          root: "developerHalleyx",
          impersonation: false,
          externalReference: [
            {
              name: "",
              externalIdentifierType: "linkedIn",
            },
          ],
          notes: [],
          birthDate: "",
          title: "",
          contactMedium: [
            {
              preferred: false,
              mediumType: "email",
              characteristic: {
                emailAddress: "petter@gmail.com",
              },
            },
            {
              mediumType: "phone",
              characteristic: {
                phoneNumber: {
                  value: "",
                  valid: true,
                  country: {
                    name: "United Kingdom",
                    short: "GB",
                    flags: "https://flagcdn.com/gb.svg",
                    dial_code: "+44",
                  },
                },
              },
              preferred: false,
            },
            {
              mediumType: "postalAddress",
              characteristic: {
                city: "",
                country: "",
                postCode: "",
                stateOrProvince: "",
                street1: "",
                street2: "",
                timezone: "",
                description: "",
                "@type": "",
              },
              preferred: false,
            },
          ],
          givenName: "jonpetter",
          familyName: "jonpetter",
          otherName: [],
          individualIdentification: [],
          disability: [],
          languageAbility: [],
          attachment: [],
          skill: [],
          relatedParty: [],
          status: "Active",
          createdAt: "2024-06-25T03:09:05.495Z",
          lastVisit: "2024-06-25T03:09:05.495Z",
          lastUpdate: "2024-06-25T03:09:05.495Z",
          displayID: "CMC-0004",
          "@baseType": "customer",
          __v: 0,
          role: [
            {
              _id: "667a364f1400e9354a660063",
              name: "Business admin",
              "@type": "partyRole",
              relatedParty: [
                {
                  id: "667a364f1400e9354a66004b",
                },
              ],
              account: [],
              paymentMethod: [],
              contactMedium: [],
              characteristic: [],
              creditProfile: [],
              lastUpdate: "2024-06-25T03:09:05.870Z",
              agreement: [],
              privilage: [],
              __v: 0,
            },
          ],
        },
      ],
      email: `
<template>

    <hlx-email
        :recipient="emailData"
        :show="shomail"
        :type="'individual'"
        @upload-data="valuemail"
        @close="shomail = false"
      />
  
</template>

<script>
export default {
data(){
  return{
    shomail: false,
      emailData: [
        "john.doe@example.com",
        "jane.smith@example.com",
        "michael.johnson@example.com",
        "emily.wilson@example.com",
        "david.brown@example.com",
        "sarah.miller@example.com",
        "james.taylor@example.com",
        "lisa.anderson@example.com",
        "robert.thomas@example.com"
      ],
  }
}
}
</\script>`,
      editor_theme: "light",
      event_data: [
        {
          name: "close",
          description:
            "Triggers when the close button is clicked or when clicked outside the modal window",
          parameter: "",
        },
        {
          name: "upload-data",
          description: "emits the value",
          parameter: "",
        },
      ],
      events: [
        {
          prop: "name",
          label: "Event name",
          width: 100,
          type: "string",
          format: "",
        },
        {
          prop: "description",
          label: "Description",
          width: 350,
          type: "string",
          format: "",
        },
        {
          prop: "parameter",
          label: "Parameter",
          width: 100,
          type: "string",
          format: "",
        },
      ],
      defaultTo: "keerthika.k2002@gmail.com",
      table_data: [
        {
          attribute: "recipient",
          description:
            "Adds animation to the labels whenever the input is focused",
          type: "Array",
          accepted_values: "-",
          default: "-",
          mandatory: false,
        },
        {
          attribute: "show",
          description:
            "Define a boolean variable in data section to open and close the email",
          type: "Boolean",
          accepted_values: "true,false",
          default: "false",
          mandatory: true,
        },
        {
          attribute: "type",
          description: "For send single or mutlti email",
          type: "String ",
          accepted_values: "individual/multi",
          default: "-",
          mandatory: false,
        },
      ],
      treeAttributes: [
        {
          prop: "attribute",
          label: "Name",
          width: 100,
          type: "string",
          format: "",
        },
        {
          prop: "description",
          label: "Description",
          width: 250,
          type: "string",
          format: "",
        },
        {
          prop: "type",
          label: "Type",
          width: 50,
          type: "string",
          format: "",
        },
        {
          prop: "accepted_values",
          label: "Accepted values",
          width: 150,
          type: "string",
          format: "",
        },
        {
          prop: "default",
          label: "Default",
          width: 80,
          type: "string",
          format: "",
        },
        {
          prop: "mandatory",
          label: "Mandatory",
          width: 90,
          type: "string",
          format: "",
        },
      ],
    };
  },
  watch: {
    isLoadervar: {
      handler(val) {
        console.log(val);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    emailAttachment() {
      setTimeout(() => {
        this.isLoadervar = false;
      }, 2000);
      this.isLoadervar = true;
    },
    valuemail(val) {
      console.log(val, "email");
    },
    shomailfh() {
      this.shomail = true;
      this.component += 1;
    },
    handleEnter() {
      if (this.inputValue.trim() !== "") {
        this.enteredValues.push(this.inputValue); // Add entered value to the beginning of the array
        this.inputValue = ""; // Clear the input field
      }
    },
    updatedEmail(val) {
      console.log(val, "updated-email-content");
      if (val.attachments.length > 0) {
        setTimeout(() => {
          this.loadAttachmnet = false;
        }, 1000);
        this.loadAttachmnet = true;
      }
      console.log(this.loadAttachmnet, "this.loadAttachmnet");
    },

    showCode(val) {
      document.getElementById(val + "-icon").classList.toggle("active-icon");
      if (document.getElementById(val).style.display === "none") {
        document.getElementById(val).style.display = "block";
      } else if (document.getElementById(val).style.display === "block") {
        document.getElementById(val).style.display = "none";
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
